import { axiosClient } from "./axios-client";
import { api } from "./endpoints";

// Raw shape returned by the admin API (backend/src/models/CompanyProfile.js), public subset.
export type CompanyProfile = {
  companyName: string;
  mission: string;
  address: string;
  email: string;
  phone: string;
  logoUrl: string;
  website: string;
  socialLinks: {
    facebook: string;
    twitter: string;
    linkedin: string;
    instagram: string;
    youtube: string;
  };
};

type Envelope<T> = {
  success: boolean;
  data: T;
};

// The response interceptor already unwraps axios's own `response.data`, so what resolves here is
// the backend's own envelope: { success, data } — not the profile object directly.
export const getCompanyProfile = async (): Promise<CompanyProfile> => {
  const envelope = (await axiosClient.get(api.getCompanyProfile)) as unknown as Envelope<CompanyProfile>;
  return envelope.data;
};
